import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(100%)', // Empieza desde la derecha
    },
    '100%': {
      transform: 'translateX(0)', // Termina en su posición original
    },
  },
  blogsContainer: {
    animation: '$slideIn 1s ease-out',
    textAlign: 'center',
    padding: '1rem',
    color: '#fff',
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
  showMoreButton: {
    padding: '1rem',
    color: '#fff',
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    borderRadius: '100px',
    cursor: 'pointer',
    marginBottom: '2rem',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000',
    },
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
  homeSubtitleDescription: {
    marginBottom: '3.5rem',
    '@media (max-width: 1200px)': {
      marginBottom: '2rem',
    },
  },
  cardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '3rem',
    marginTop: '2rem',
    flexWrap: 'wrap',
    '@media (max-width: 1200px)': {
      gap: '1.5rem',
      marginTop: '1.5rem',
    },
  },
  card: {
    width: '250px',
    textAlign: 'center',
    backgroundColor: 'transparent',
    color: '#fff',
    border: '2px solid #fff',
    borderRadius: '10px',
    padding: '1rem',
    boxShadow: '0 4px 6px rgba(255, 255, 255, 0.1)',
    '@media (max-width: 1200px)': {
      width: '200px',
      padding: '0.8rem',
    },
  },
  cardImage: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    marginBottom: '1rem',
    borderRadius: '50%',
    '@media (max-width: 1200px)': {
      width: '80px',
      height: '80px',
    },
  },
  cardTitle: {
    margin: '0.5rem 0',
    background: 'linear-gradient(126deg, rgba(0,168,232,1) 2%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  cardDescription: {
    color: '#ddd',
  },
});

export default useStyles;
